<div class="button" [ngClass]="classObject">
  <i class="fas fa-spinner fa-spin" *ngIf="_isSpinning"> </i>
  <ng-content></ng-content>
</div>
